import React from 'react';
export const IconNewApp = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20.785",
  height: "24.472",
  viewBox: "0 0 20.785 24.472"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_15230",
  transform: "translate(12.289 0.1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_16692",
  transform: "translate(-12.189 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_6918",
  d: "M2.306,24.272A2.308,2.308,0,0,1,0,21.966V2.507A2.476,2.476,0,0,1,2.306,0H18.279a2.309,2.309,0,0,1,2.306,2.306V16.118a.684.684,0,0,1-.684.683h-.71V2.305a.913.913,0,0,0-.911-.911H2.306c-.505,0-.912.609-.912,1.114V21.966a.913.913,0,0,0,.912.912H18.279a.913.913,0,0,0,.912-.912v-2.9a.684.684,0,0,1,.684-.683h.71v3.586a2.308,2.308,0,0,1-2.306,2.306Z",
  transform: "translate(0 0)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_6919",
  d: "M17.272,16.4a3.337,3.337,0,1,1,3.337-3.336A3.317,3.317,0,0,1,17.272,16.4m0-5.24a1.9,1.9,0,1,0,1.9,1.9,1.906,1.906,0,0,0-1.9-1.9",
  transform: "translate(-6.98 -4.872)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_6920",
  d: "M8.4,31.354v-.5a.889.889,0,0,1,.888-.888H20.6v.5a.889.889,0,0,1-.888.888Z",
  transform: "translate(-4.208 -15.852)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_6922",
  d: "M10.571,44.262v-.5a.889.889,0,0,1,.888-.888H20.6v.5a.889.889,0,0,1-.888.887Z",
  transform: "translate(-5.294 -24.848)",
  fill: "currentColor"
}))));